import { UserId } from './user.model';

export class LoginReponse {
  constructor(
    private token: string,
    private userId: UserId
  ) { }

  public getToken(): string {
    return this.token;
  }

  public getUserId(): UserId {
    return this.userId;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/user/login-response.model.ts